'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _FontIcon = require('./FontIcon');

exports.default = _FontIcon.FontIcon;
exports.FontIcon = _FontIcon.FontIcon;


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/react-toolbox/lib/font_icon/index.js
// module id = 23
// module chunks = 4